// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--iqsNJ","wrapper":"_0bc5e8de02--wrapper--SaOY9","icon":"_0bc5e8de02--icon--aqcS0","remoteness":"_0bc5e8de02--remoteness--j_jU9"};